import { roles } from '../../config/roles';
import { Analysis } from '../../types';
import { truncateText } from '../../utils/textUtils';
import AnalysisActions from './AnalysisActions';
import { Calendar, FileText } from 'lucide-react';

interface AnalysisCardProps {
  analysis: Analysis;
  onView: (analysis: Analysis) => void;
  onDelete: (analysis: Analysis) => void;
}

export default function AnalysisCard({ analysis, onView, onDelete }: AnalysisCardProps) {
  const role = roles.find(r => r.id === analysis.roleId);

  return (
    <div className="bg-white dark:bg-navy-900 rounded-xl shadow-lg border border-navy-200 dark:border-navy-700 p-6 relative group hover:shadow-xl hover:border-accent-400/50 dark:hover:border-accent-400/30 transition-all duration-300">
      <div
        className="cursor-pointer"
        onClick={() => onView(analysis)}
      >
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-accent-400/10 dark:bg-accent-400/20 rounded-lg">
              <FileText className="h-4 w-4 text-accent-500 dark:text-accent-400" />
            </div>
            <h3 className="font-semibold text-navy-900 dark:text-navy-50 line-clamp-1">
              {analysis.fileName}
            </h3>
          </div>
        </div>

        {role && (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-navy-100 dark:bg-navy-800 text-navy-600 dark:text-navy-300 mb-3">
            {role.name}
          </span>
        )}

        <div className="text-sm text-navy-600 dark:text-navy-300 line-clamp-3 mb-4">
          {truncateText(analysis.ementa || analysis.analysis, 200)}
        </div>

        <div className="flex items-center text-xs text-navy-500 dark:text-navy-400 pt-3 border-t border-navy-100 dark:border-navy-800">
          <Calendar className="h-3.5 w-3.5 mr-1.5" />
          {new Date(analysis.createdAt).toLocaleDateString('pt-BR')}
        </div>
      </div>

      <div className="absolute top-4 right-4 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-all duration-200">
        <AnalysisActions
          analysis={analysis}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
}
